/** The index key of an uuid at a chain of list positions: `{uuid}@{p0}.{p1}…`. */
const buildPositionKey = (uuid: string, positions: readonly number[]): string =>
	`${uuid}@${positions.join('.')}`;

export default buildPositionKey;
